"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeManager = void 0;
var mobx_1 = require("mobx");
var SideBySide_1 = require("ContentTokens/DataModels/SideBySide");
var observe_rect_1 = __importDefault(require("@reach/observe-rect"));
var CONTENT_CONTAINER_SELECTOR = ".project-block";
var ResizeManager = (function () {
    function ResizeManager() {
        var _this = this;
        this.SMALL_SCREEN_BREAKPOINT = 1140;
        this.SMALL_TO_MEDDIUM_SCREEN_BREAKPOINT = 1440;
        this.SMALL_SCREEN_WIDE_SIZE_RATIO = 1.15;
        this.WIDE_SCREEN_WIDE_SIZE_RATIO = 1.33;
        this.SELECTOR_PADDING = 32;
        this.CONTENT_PADDING = 50;
        this._mouseStart = 0;
        this._dragStartSize = 0;
        this._draggingSize = 0;
        this._resizing = false;
        this._widthRange = SideBySide_1.SideBySideWidth.Wide;
        this._contentAreaWidth = "100vw";
        this.setGridContainer = function (ref, onResizeComplete, onSelectSideBySide) {
            _this._resizeGridRef = ref;
            _this.onResizeComplete = onResizeComplete;
            _this.onSelectSideBySide = onSelectSideBySide;
        };
        this.calculateActiveWidthRange = function (smallGridWidth) {
            var browserViewport = _this.getBrowserViewport();
            var mediumGridRatio = _this.WIDE_SCREEN_WIDE_SIZE_RATIO;
            if (browserViewport > _this.SMALL_SCREEN_BREAKPOINT && browserViewport <= _this.SMALL_TO_MEDDIUM_SCREEN_BREAKPOINT) {
                var contentWidth = smallGridWidth - _this.SELECTOR_PADDING + _this.CONTENT_PADDING;
                if (contentWidth / _this.SMALL_SCREEN_BREAKPOINT >= 0.9) {
                    mediumGridRatio = _this.SMALL_SCREEN_WIDE_SIZE_RATIO;
                }
            }
            if (browserViewport <= _this.SMALL_SCREEN_BREAKPOINT) {
                mediumGridRatio = _this.SMALL_SCREEN_WIDE_SIZE_RATIO;
            }
            _this.setActiveWidthRange(smallGridWidth, smallGridWidth * mediumGridRatio);
        };
        this.setActiveWidthRange = function (smallGridWidth, mediumGridWidth) {
            if (_this._draggingSize <= smallGridWidth) {
                _this._widthRange = SideBySide_1.SideBySideWidth.Content;
            }
            if (_this._draggingSize > smallGridWidth) {
                _this._widthRange = SideBySide_1.SideBySideWidth.Wide;
            }
            if (_this._draggingSize > mediumGridWidth) {
                _this._widthRange = SideBySide_1.SideBySideWidth.Full;
            }
        };
        this.prepareResizing = function (element) {
            _this.setupResizeListeners(element);
        };
        this.cleanupResizing = function () {
            var _a;
            (_a = _this.contentContainerObserver) === null || _a === void 0 ? void 0 : _a.unobserve();
        };
        this.setStartSize = function (size) {
            _this._dragStartSize = size;
            _this._draggingSize = size;
        };
        this.handleMouseDown = function (event) {
            event.preventDefault();
            var currentSize = _this._sideBySideContainerRef.current.offsetWidth;
            _this.startResizing(currentSize, event.clientX);
        };
        this.startResizing = function (startSize, mouseStart) {
            _this._resizing = true;
            _this._mouseStart = mouseStart;
            _this.setStartSize(startSize);
            document.body.style.cursor = "ew-resize";
            document.addEventListener("mousemove", _this.hanldeMouseMove);
            document.addEventListener("mouseup", _this.handleMouseUp);
        };
        this.handleMouseUp = function (event) {
            _this._resizing = false;
            _this.onResizeComplete(_this._widthRange);
            _this.onSelectSideBySide();
            document.body.style.cursor = "";
            document.removeEventListener("mouseup", _this.handleMouseUp);
            document.removeEventListener("mousemove", _this.hanldeMouseMove);
        };
        this.hanldeMouseMove = function (event) {
            var _a, _b;
            if (_this._resizing) {
                var browserViewport = _this.getBrowserViewport();
                var isLeftResizing = _this._mouseStart < browserViewport / 2;
                var difference = (_this._mouseStart - event.pageX) * 2;
                var size = isLeftResizing ? _this._dragStartSize + difference : _this._dragStartSize - difference;
                var centerGrid = (_b = (_a = _this._resizeGridRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.childNodes[2];
                if (!!centerGrid) {
                    var smallGridWidth = centerGrid.clientWidth;
                    if (size + _this.SELECTOR_PADDING <= smallGridWidth) {
                        _this._draggingSize = smallGridWidth - _this.SELECTOR_PADDING;
                    }
                    else {
                        _this._draggingSize = size;
                    }
                    _this.calculateActiveWidthRange(smallGridWidth);
                }
            }
        };
        this.getBrowserViewport = function () {
            return window.innerWidth || document.documentElement.clientWidth;
        };
        this.onResizeContentContainer = function (rect) {
            _this._contentAreaWidth = "".concat(rect.width, "px");
        };
        this.setupResizeListeners = function (element) {
            var contentContainer = element.closest(CONTENT_CONTAINER_SELECTOR);
            if (contentContainer) {
                _this.contentContainerObserver = (0, observe_rect_1.default)(contentContainer, _this.onResizeContentContainer);
                _this.contentContainerObserver.observe();
            }
            else {
                console.warn("No ".concat(CONTENT_CONTAINER_SELECTOR, " to size side-by-side"));
            }
        };
        this.setResizeContainer = function (containerRef) {
            _this._sideBySideContainerRef = containerRef;
        };
    }
    Object.defineProperty(ResizeManager.prototype, "isResizing", {
        get: function () {
            return this._resizing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResizeManager.prototype, "contentAreaWidth", {
        get: function () {
            return this._contentAreaWidth;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResizeManager.prototype, "draggingSize", {
        get: function () {
            return this._draggingSize;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResizeManager.prototype, "resizeGridRef", {
        get: function () {
            return this._resizeGridRef;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ResizeManager.prototype, "widthRange", {
        get: function () {
            return this._widthRange;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], ResizeManager.prototype, "_draggingSize", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], ResizeManager.prototype, "_resizing", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof SideBySide_1.SideBySideWidth !== "undefined" && SideBySide_1.SideBySideWidth) === "function" ? _a : Object)
    ], ResizeManager.prototype, "_widthRange", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ResizeManager.prototype, "_contentAreaWidth", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizeManager.prototype, "calculateActiveWidthRange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizeManager.prototype, "setActiveWidthRange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizeManager.prototype, "prepareResizing", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizeManager.prototype, "setStartSize", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizeManager.prototype, "handleMouseDown", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizeManager.prototype, "startResizing", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizeManager.prototype, "handleMouseUp", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizeManager.prototype, "hanldeMouseMove", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ResizeManager.prototype, "onResizeContentContainer", void 0);
    return ResizeManager;
}());
exports.ResizeManager = ResizeManager;
